var EventEmitter = require("events");
module.exports = new EventEmitter();



//////////////////
// WEBPACK FOOTER
// (webpack)/hot/emitter.js
// module id = 172
// module chunks = 0